// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doc-root[data-v-2293cdc0]{width:100vw;height:100vh}", ""]);
// Exports
module.exports = exports;
